import { Chapter, TraditionalChapter } from "./chapter.model";
import { MediaFile } from "./media.model";

export class Course {
  constructor(
    public id: string = "",
    public name: string = "",
    public description: string = "",
    public teacher: any = {},
    public summary: string = "",
    public categories: any[] = [],
    public chapters?: Chapter[],
    public status?: string,
    public file?: MediaFile,
    public progress?: number,
    public duration?: number,
    public done?: boolean,
    public learningObjectiveStatus?: string,
    public lastDoneMaterial?: boolean,
    public currentObjective?: string,
    public pastObjectiveId?: string,
    public adaptive?: boolean,
    public type?: CourseType,
    public hasCertificate?: boolean,
    public classroom?: { id: string; name: string },
    public certificateId?: string,
    public certificateName?: string,
    public certificateTemplate?: string,
    public h5pId?: number
  ) {}
}

export enum CourseType {
  LINEAR = "LINEAR",
  ADAPTATIVE = "ADAPTATIVE",
  INTERACTIVE = "INTERACTIVE",
}

export class CourseTraditional {
  constructor(
    public id: string = "",
    public name: string = "",
    public description: string = "",
    public summary: string = "",
    public chapters: TraditionalChapter[] = [],
    public percentageDone: number = 0,
    public file?: MediaFile
  ) {}
}

export class LinearPercentages {
  constructor(
    public trailPercentage: number = 0,
    public coursePercentage: number = 0
  ) {}
}

export class Status {
  public static readonly PUBLISHED = "PUBLISHED";
  public static readonly REPROVED = "REPROVED";
  public static readonly APPROVED = "APPROVED";
  public static readonly WAITING = "WAITING";
  public static readonly NOT_PUBLISHED = "NOT_PUBLISHED";
  public static readonly NOT_LISTED = "NOT_LISTED";
}
